'use strict'

import { addDays, endOfMonth, format, parseISO, startOfMonth } from 'date-fns';
import { uniq } from 'lodash';

import { loadComponent } from './utils/load-component';
import zonedDate from '../utils/zoned-date';

const now = zonedDate();
const todayString = format(now, 'yyyy-MM-dd');

loadComponent(
    'date-selector',
    {
        props: [],
        data: function () {
            return {
                ViewModel: {
                    Months: []
                },
            };
        },

        beforeMount: function () {
            this.$root.$on('DatePicker.updateCalendarDates', this.updateCalendarDates);
        },

        methods: {
            dateClicked: function (day) {
                this.$root.$emit('DatePicker.selectedDate', day.Date);
            },
            updateCalendarDates: function (newDates) {
                const orderedDates = uniq(newDates).map(date => {
                    return parseISO(date, 'yyyy-MM-dd', now);
                }).sort((a, b) => {
                    return a > b ? 1 : -1;
                });

                if (!orderedDates.length) {
                    this.ViewModel.Months = [];
                    return;
                }

                // Beginning of month
                let testDate = startOfMonth(orderedDates[0]);
                // End of month
                let lastDate = endOfMonth(orderedDates[orderedDates.length - 1]);

                const months = [];
                while(testDate < lastDate) {
                    // Checks to see if the month has alreday been added
                    let month = months.find(month => month.Month === format(testDate, 'MMMM') && month.Year === format(testDate, 'yyyy'));

                    if (!month) {
                        // Checks how many empty days need to be added at the beginning of the month based on the start day (week starts on Monday)
                        let monthPadding = parseInt(format(testDate, 'c'), 10) - 1;
                        monthPadding = monthPadding === -1 ? 6 : monthPadding;
                        month = {
                            Year: format(testDate, 'yyyy'),
                            Month: format(testDate, 'MMMM'),
                            Days: Array.apply(null, Array(monthPadding)).map(() => ({})),     // Pads the days at the begninning of the month
                        };
                        months.push(month);
                    }
                    const dateString = format(testDate, 'yyyy-MM-dd');

                    const day = {
                        Day: format(testDate, 'd'),
                        Today: dateString === todayString,
                        Events: newDates.indexOf(dateString) > -1,
                        Date: dateString,
                    };
                    month.Days.push(day);
                    testDate = addDays(testDate, 1);
                }

                this.ViewModel.Months = months;
            },
        },
    }
)
